<template>
	<el-button-group :class="{'one-line': !wrap, 'frm-group': group}">
		<slot />
	</el-button-group>
</template>

<script>
import { DmsBaseComponent } from '#components/dms/common/base';

export default DmsBaseComponent.extend({
	name: 'DmsButtonGroup',
	props: {
		wrap: { type: Boolean, default: true },
		group: Boolean,
	},
});
</script>
